import { type EmptyApiRequest, SECOND, type AreaJobListSuccess } from '@terros/common'
import { type TinyQueryOptions, useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'

const POLL_INTERVAL = 5 * SECOND

export function useAreaJobList(options?: TinyQueryOptions): GetHookResponse<AreaJobListSuccess> {
  return useTantalimQuery<EmptyApiRequest, AreaJobListSuccess, AreaJobListSuccess>({
    url: '/area/job/list',
    queryKey: ['area-job-list'],
    input: {},
    convertResponse: (data) => data,
    options: {
      staleTime: POLL_INTERVAL,
      refetchInterval: POLL_INTERVAL,
      ...options,
    },
  })
}
